module.exports = __webpack_public_path__ + "static/media/user-icon-form.efc5a071.svg";